export const en = {
  title: 'Support Chat',
  greeting: 'Hi! How can I help you today?',
  inputPlaceholder: 'Type a message...',
  inputPlaceholderEmail: 'Enter your email address...',
  inputPlaceholderOtp: 'Enter 6-digit verification code...',
  send: 'Send',
  stop: 'Stop',
  attachFile: 'Attach file',
  authPrompt: 'Welcome! To get started, please enter your email address.',
  authOtpSent: "We've sent a 6-digit verification code to {email}. Please enter it below.",
  authVerified: 'Verified as {email}',
  authSuccess: "You're all set! How can I help you today?",
  authInvalidEmail: "That doesn't look like a valid email address. Please try again.",
  authInvalidOtp: 'Please enter the 6-digit code we sent to your email.',
  authVerifyFailed: 'That code didn\'t work. Please check and try again.',
  authSendFailed: 'Something went wrong sending the code. Please try again.',
  uploading: 'Uploading...',
  uploadError: 'Upload failed. Try again.',
  networkError: 'Connection lost. Retrying...',
  retry: 'Retry',
  close: 'Close',
  minimize: 'Minimize',
  today: 'Today',
  yesterday: 'Yesterday',
  dragDropHint: 'Drop file here or click to browse',
  fileTooLarge: 'File is too large',
  invalidFileType: 'File type not supported',
  toolCalling: 'Calling {tool}...',
  toolDone: 'Done',
  toolError: 'Failed',
  analystStarted: 'Analyzing the data...',
  analystThinking: 'Planning the analysis (step {round})...',
  analystQuerying: 'Running calculations (step {round})...',
  analystSaving: 'Checking the result...',
  analystFixing: 'Refining the calculation...',
  chatError: 'Sorry, an error occurred. Please try again.',
  chatTimeout: 'The request took too long. Please try again.',
  dismiss: 'Dismiss',
  mcpConnecting: 'Connecting to tools...',
  mcpConnected: 'Tools ready',
  mcpFailed: 'Could not connect to tools',
  formSubmit: 'Submit',
  formCancel: 'Cancel',
  formApprove: 'Approve',
  formReject: 'Reject',
  confirmationTitle: 'Confirm action: {tool}',
  confirmationParamsTitle: 'Enter parameters for: {tool}',
  confirmationApproved: 'Approved',
  confirmationRejected: 'Rejected',
  confirmationTimedOut: 'Request timed out',
  formRequired: 'This field is required',
  authSsoButton: 'Sign in with {provider}',
  authSsoPending: 'Complete sign-in in the popup window',
  authSsoFailed: 'Sign-in failed. Please try again.',
  authSsoCancelled: 'Sign-in was cancelled.',
  rateLimited: 'Please wait a moment before sending another message.',
  rateLimitCountdown: 'Too many messages. Please wait {seconds}s...',
  captchaPrompt: 'Solve to continue:',
  captchaVerify: 'Verify',
  captchaFailed: 'Wrong answer. Try again.',
  widgetUnavailable: 'Chat Unavailable',
  widgetUnavailableDesc: 'This chat is currently inactive. Please try again later.',

  // Voice (regular chat)
  voiceInput: 'Voice input',
  voiceInputListening: 'Listening...',
  readAloud: 'Read aloud',
  stopReading: 'Stop reading',

  // Driving mode
  drivingMode: 'Driving Mode',
  drivingModeExit: 'Exit',
  drivingModeListening: 'Listening...',
  drivingModeProcessing: 'Processing...',
  drivingModeSpeaking: 'Speaking...',
  drivingModeIdle: 'Ready',
  drivingModeTapToSpeak: 'Tap to speak',
  drivingModeTapToStop: 'Tap to stop',
  drivingModeEmptyResponse: 'Send a voice message to get started',
  drivingModeGoodbye: 'Goodbye! Driving mode is now closed.',
  drivingModeRepeat: 'Repeat',
  drivingModeSpeed: 'Voice speed',
  drivingModeAudioOutput: 'Audio output',
  drivingModeAudioOutputDefault: 'Browser default',
  drivingModeCueSounds: 'Cue sounds',
  drivingModeCueSoundsOn: 'Cue sounds on',
  drivingModeCueSoundsOff: 'Cue sounds off',

  // Keypad
  keypadOpen: 'Keypad',
  keypadSend: 'Send',
  keypadHint: 'Enter number',
  keypadClose: 'Close keypad',

  // Speech errors
  sttNotSupported: 'Speech recognition is not supported in this browser. Please use Chrome or Edge.',
  sttPermissionDenied: 'Microphone access was denied. Please allow microphone access and try again.',
  sttNoSpeech: 'No speech detected. Try again.',
  sttNetworkError: 'Network error during speech recognition.',
  sttApiKeyMissing: 'Voice input is unavailable because no OpenAI API key is configured for speech-to-text.',

  // Portal (sidebar)
  portalNewChat: 'New chat',
  portalLoading: 'Loading...',
  portalNoConversations: 'No previous conversations',
  portalUntitledConversation: 'Untitled conversation',
  portalTurnTimedOut: 'Timed out',
  portalTurnError: 'Error',
  portalDeleteConversation: 'Delete conversation',
  portalGuest: 'Guest',
  portalLogout: 'Logout',
  portalHideMenu: 'Hide menu',
  portalShowMenu: 'Show menu',
  portalLast7Days: 'Last 7 days',
  portalOlder: 'Older',
  portalInvalidLink: 'Invalid Link',
  portalInvalidLinkDesc: 'This chat link is not valid. Please check the URL and try again.',
} as const;

export type TranslationKey = keyof typeof en;
